var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap, switchMapTo } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { selectIsModalOpen, selectModalTabId } from "../../../selectors/selectModalTabId";
import { selectOutskirtBuildingInfo } from "../../../selectors/selectOutskirtBuildingInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionActionButtonResetIteration } from "../../hud-action-button/actionHudActionButton";
import { IdActionButtonEntries } from "../../hud-action-button/IdActionButtonEntries";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionOutskirtsInfoUpdate } from "../../info/outskirts/actionOutskirtsInfo";
import { actionLimitedActionInfoFetch } from "../../limited-action-info/actionLimitedActionInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionDoghouse } from "../actionDoghouse";
import { DoghouseCategory } from "../DoghouseCategory";
import { IdDoghouseTreatPackage } from "../IdDoghouseTreatPackage";
export var epicDoghouseGiveTreat = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionDoghouse.GiveTreat), switchMap(function () {
        var state = state$.value;
        var tab = selectModalTabId(state, IdModal.Doghouse);
        var packageId = IdDoghouseTreatPackage.Premium;
        var actions = [];
        var isDogTreatDialogOpen = selectIsModalOpen(state, IdModal.DogTreatReward);
        if (isDogTreatDialogOpen) {
            actions.push(actionModalClose(IdModal.DogTreatReward));
        }
        if (tab === DoghouseCategory.GiveDoghouseBone) {
            packageId = IdDoghouseTreatPackage.Standard;
            var standardTreat = selectInventoryResourceInfo(state, IdResource.DogtreatStandard);
            var doghouseInfo = selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Doghouse);
            var givenStandardTreatAmount = doghouseInfo && doghouseInfo.proto ? doghouseInfo.proto.amount || 0 : 0;
            actions.push(actionLimitedActionInfoFetch());
            actions.push(actionActionButtonResetIteration(IdActionButtonEntries.Dog));
            actions.push(actionInventoryInfoRemoveResource([
                __assign({}, standardTreat, { amount: Long.ONE }),
            ]));
            actions.push(actionOutskirtsInfoUpdate({
                amount: givenStandardTreatAmount + 1,
                typeId: IdOutskirtBuildings.Doghouse,
            }));
        }
        else {
            var premiumTreat = selectInventoryResourceInfo(state, IdResource.DogtreatPremium);
            actions.push(actionInventoryInfoRemoveResource([
                __assign({}, premiumTreat, { amount: Long.ONE }),
            ]));
        }
        return deps
            .netSend({
            id: CommandCode.BuyDogPackage,
            props: {
                packageId: packageId,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(retry(), switchMapTo(from(actions)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/epics/epicDoghouseGiveTreat.ts
// module id = 1838
// module chunks = 3